import { useEffect } from 'react';
import { Route, Routes, useMatch } from 'react-router';
import { Col, Nav, NavItem, Row, Spinner } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { getUserHubsSummary } from '../../slice';

import { NavLink } from 'react-router-dom';
import {
  dateDifferenceInDaysFromToday,
  formatDecimalNumber,
  formatUSD
} from '../../../../../helpers/helpers';
import { Tile } from '../../../../../Components/Custom/Tile';

import { Travel } from './sections/Travel';
import { UnicaPay } from './sections/UnicaPay';
import { Minara } from './sections/Minara';
import { U1Academy } from './sections/U1Academy';
import { FuturaMining } from './sections/FuturaMining';

const nestedPages = [
  {
    name: 'Packages',
    route: 'travel',
    component: Travel
  },
  {
    name: 'Unica Pay',
    route: 'unicapay',
    component: UnicaPay
  },
  {
    name: 'Minara',
    route: 'minara',
    component: Minara
  },
  {
    name: 'U1 Academy',
    route: 'unitedoneacademy',
    component: U1Academy
  },
  {
    name: 'Futura Mining',
    route: 'futuramining',
    component: FuturaMining
  }
];

export const Hubs = () => {
  const dispatch = useAppDispatch();

  const { data, loading, walletSummary, lifetimeRank, qualifiedRank } =
    useAppSelector((state) => state.userDetails);

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getUserHubsSummary(Number(userId)));
  }, []);

  return (
    <div>
      <h5>My Membership Status</h5>
      <Row>
        <Tile label='BACK OFFICE SUBSCRIPTION'>
          {Number(dateDifferenceInDaysFromToday(data.licenceEndDate)) < 1 ? (
            'EXPIRED'
          ) : (
            <>
              {dateDifferenceInDaysFromToday(data.licenceEndDate)}
              <span className='s-14'> DAYS LEFT</span>
            </>
          )}
        </Tile>
        <Tile label='CURRENT RANK'>{lifetimeRank}</Tile>
        <Tile label='TOTAL PERSONAL ORDERS'>
          <>{formatUSD(walletSummary?.totalOrder)} </>
          <span className='fs-14'> USDT</span>
        </Tile>
      </Row>

      <Nav
        className='nav-tabs-custom rounded  border-bottom-0 mb-4 mt-4'
        role='tablist'>
        {nestedPages.map((page, i) => (
          <NavItem key={i}>
            <NavLink to={page.route} className='nav-link'>
              <i className='fas fa-home'></i>

              {page.name}
            </NavLink>
          </NavItem>
        ))}

        {loading && (
          <div className='d-flex align-items-center'>
            <Spinner size='sm' className='primary' />
          </div>
        )}
      </Nav>

      <Routes>
        {nestedPages.map((page, i) => (
          <Route key={i} path={page.route} element={<page.component />} />
        ))}
      </Routes>
    </div>
  );
};
